import React from 'react'

import { FORMULA_OPERAND_MIN_WIDTH } from 'components_new/molecules/FormulaBlock'
import FormulaTypeButton from 'components_new/molecules/FormulaBlock/TypeButton'
import { OptionProps } from 'components_new/molecules/OptionsMenu'
import SelectSearch from 'components_new/molecules/SelectSearch'

export interface FormulaOperandSelectProps {
  onChange: (id: string) => void
  options: { id: string; title: string }[]
  placeholder: string
  selectedId: string | null
  /** What the operand can be changed into, behind the pencil. */
  typeOptions: OptionProps[]
}

/**
 * An operand picked from a list — searchable, since the lists run long, with
 * the pencil that changes what the operand is where the field's own icon
 * would be.
 */
const FormulaOperandSelect = (props: FormulaOperandSelectProps) => {
  const { onChange, options, placeholder, selectedId, typeOptions } = props

  return (
    <SelectSearch
      closeOnSelect
      customIcon={<FormulaTypeButton options={typeOptions} sx={{ mr: 1 }} />}
      disableClearable={true}
      multiple={false}
      noGutter={true}
      onChange={(value) => onChange(value?.id ?? '')}
      options={options}
      placeholder={placeholder}
      selected={options.find((option) => option.id === selectedId) ?? null}
      size="small"
      sx={{ minWidth: FORMULA_OPERAND_MIN_WIDTH }}
    />
  )
}

export default FormulaOperandSelect
